//
//
//
//
import FormComponent from './form.vue';
export default {
  name: 'report-center-detail',
  props: {
    id: {
      type: String,
      required: false
    }
  },
  components: {
    FormComponent: FormComponent
  }
};